import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container,TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col,Label, Input,Button, CardTitle, Badge, ModalFooter, InputGroup, InputGroupText } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import {  Modal,ModalBody, ModalHeader} from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { AddZone, disableZone, enableZone, GetlisteZones, updateZone, UploadFileZone } from '../../services/ZonesServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile } from "../../services/ProfileServices/Api";
import Dropzone from "react-dropzone";
import { Form } from "react-router-dom";
import config from '../../config'
import { AddPage, disablePage, enablepage, GetlistePages, updatePage, UploadFilePage } from "../../services/PageServices/Api";
import { AddQuiz, disableQuiz, enableQuiz, GetlisteQuiz, removeQuiz, updateQuiz, UploadFileQuiz } from "../../services/QuizServices/Api";
import { colors } from "../../helpers/colors";
import { AvField, AvForm } from "availity-reactstrap-validation";

const Quiz = () => {
  const [modalUpdateIsOpen,setmodalUpdateIsOpen] = useState(false)
  const [ListZones,setListZones] = useState([])
  const [User,setUser] = useState()
  const [dropdownValues, setDropdownValues] = useState({});
  const  [openmodal, setopenModal] = useState(false)
  const [activeTabJustify,setactiveTabJustify] = useState("1")
  const [memberSelected , setmemberSelected] = useState()
  const [selectedCity , setselectedCity]  = useState("")
  const [Qst_FR , setQst_FR]  = useState("")
  const [Qst_AR , setQst_AR]  = useState("")
  const [Qst_EN , setQst_EN]  = useState("")
  const [QuiOpened , setQuiOpened] = useState({})
  const [tel , settel]  = useState("")
  const [ShowConfirmModal, setShowConfirmModal] = useState(false)
  const [ShowConfirmModalII, setShowConfirmModalII] = useState(false)
  const [ZoneSelected , setZoneSelected]  = useState("")
  const  [openedQuiz, setopenedQuiz] = useState()

  const [DesPage_Fr , setPage_Fr]  = useState("")
  const [DesPage_Ar , setPage_Ar]  = useState("")
  const [DesPage_Eng , setPage_Eng]  = useState("")

  const [adr_ferm , setadr_ferm]  = useState("")
  const [Email, setEmail] = useState()
  const [DaysSelected, setDaysSelected] = useState([])
  const [openmodalevaluate, setopenmodalevaluate] = useState(false)
  const [evaluatYear, setevaluatYear] = useState('')
  const [evaluatCmnt, setevaluatCmnt] = useState('')
  const [PageBlock, setPageBlock] = useState('')

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [ShowZones,setShowZones] = useState()

  const [Res_AR, setRes_AR] = useState([])
  const [Res_FR, setRes_FR] = useState([])
  const [Res_EN, setRes_EN] = useState([])

  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [activeTab, setactiveTab] = useState("1")
  const [errorsizeFile , seterrorsizeFile] = useState(false)
  const [ShowConfirmRemove, setShowConfirmRemove] = useState(false)
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [typeFile,settypeFile] = useState('')


 



  

  const handleClickMember = (member) =>{
     setQuiOpened(member) 
     seterrorsizeFile(false)
     setactiveTab('1')
     setQst_FR(member['qst_fr'])
     setQst_AR(member['qst_ar'])
     setQst_EN(member['qst_en'])
     setRes_AR(JSON.parse(member['reponses_ar']))
     setRes_EN(JSON.parse(member['reponses_en']))
     setRes_FR(JSON.parse(member['reponses_fr']))
     const correctRep = parseInt(member['correctReponse'])
     setSelectedCheckboxes(JSON.parse(member['correctReponse']) || [])

     setopenModal(true)
  }



  const  toggleCustomJustified = (tab) => {
		setactiveTabJustify(tab)
	}

  const  handleSelectCity = async (selectedGroup) => {
    console.log(selectedGroup)
    setselectedCity(selectedGroup);
  };


  const optionBlock = [
	{
		options: [
			{ label: "Explorez le Zoo", value: "Explorez le Zoo" },
			{ label: "Expériences", value: "Expériences" },
			{ label: "Préparez votre visite", value: "Préparez votre visite" },
			{ label: "Plan du Zoo", value: "Plan du Zoo" },

		]
	},
];



  const columns = useMemo(
    () => [
      {
        Header: "Image",
        accessor: "img",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Question",
        accessor: "qst_fr",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "disable",
        disableFilters: true,
        filterable: false,
      }
    
    ],
  );

  if((User?.role == 2 || User?.role == 3) ){
    columns.push({
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      filterable: false,
    })
  }



  const GetData = async () =>{
    await GetlisteQuiz().then(res =>{
      console.log(res)
      setsetFilterData(res)
      const filteredZones = res.filter(zone => zone.disable == false);

      //  for (let index = 0; index < res.length; index++) {
      //   res[index].nbr_ani = res[index].animaux.length
      //  }

      setListZones(res)
    
    }).catch(err =>{
      console.log(err)
    })
  }

    useEffect(() =>{
      const Data = JSON.parse(localStorage.getItem("authUser"))
      setUser(Data)

      GetData()
    },[])

    const initForm = () =>{
      setSelectedFiles([])
      setQst_AR("")
      setQst_FR("")
      setQst_EN("")
      setRes_FR([])
      setRes_AR([])
      setRes_EN([])
      setQuiOpened({})
      setSelectedCheckbox(null)
    //   setShowZones(false)
    }

    const handleAcceptedFiles = (files) => {
      const updatedFiles = files
        .filter((file) => {
          // Check file size (2MB = 2097152 bytes)
          if (file.size > 2097152) { 
            seterrorsizeFile(true);
            return false;
          }
          seterrorsizeFile(false);
          return true;
        })
        .map((file) => {
          // Detect file type
          const fileType = file.type;
          let fileCategory = '';
    
          if (fileType.startsWith('image/')) {
            fileCategory = 'Image';
          } else if (fileType.startsWith('video/')) {
            fileCategory = 'Video';
          } else if (fileType.startsWith('audio/')) {
            fileCategory = 'Audio';
          } else {
            fileCategory = 'Other';
          }
          settypeFile(fileCategory)
          // Add additional data to the file object
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
            htmlFormattedSize: htmlFormatBytes(file.size),
            category: fileCategory // Add the detected file category
          });
        });
    
      setSelectedFiles(updatedFiles);
    };
    

    const htmlFormatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

    const handleRemoveFile = (index) => {
      setSelectedFiles(prevFiles => {
          const updatedFiles = [...prevFiles];
          updatedFiles.splice(index, 1);
          return updatedFiles;
      });
  };


  const handleupdateQuiz = async () =>{
    if(selectedFiles.length !== 0 ){
      
    const formData = new FormData();
    formData.append('file', selectedFiles[0]);
      await UploadFileQuiz(formData).then(async res =>{
      QuiOpened['qst_fr'] = Qst_FR
      QuiOpened['reponses_fr'] = JSON.stringify(Res_FR)
      QuiOpened['qst_ar'] = Qst_AR
      QuiOpened['reponses_ar'] = JSON.stringify(Res_AR)
      QuiOpened['qst_en'] = Qst_EN
      QuiOpened['reponses_en'] = JSON.stringify(Res_EN)
      QuiOpened['img'] = res
      QuiOpened['typeFile'] = typeFile
      QuiOpened['updatedAt'] = new Date()
      QuiOpened['correctReponse'] = JSON.stringify(selectedCheckboxes)


      await updateQuiz(QuiOpened).then(res =>{
        console.log(res.status)
        if (res.status === 200) {
  
          toastr.success('la zone ' + Qst_FR + " était bien modifié" )
          setopenModal(false)
          initForm()
  
        } else {
          toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
  
        }
      })
    })
  } else {
    // QuiOpened['block'] = PageBlock.value
    QuiOpened['qst_fr'] = Qst_FR
    QuiOpened['reponses_fr'] = JSON.stringify(Res_FR)
    QuiOpened['qst_ar'] = Qst_AR
    QuiOpened['reponses_ar'] = JSON.stringify(Res_AR)
    QuiOpened['qst_en'] = Qst_EN
    QuiOpened['reponses_en'] = JSON.stringify(Res_EN)
    QuiOpened['updatedAt'] = new Date()
    QuiOpened['correctReponse'] = JSON.stringify(selectedCheckboxes)


    await updateQuiz(QuiOpened).then(res =>{
      console.log(res.status)
      if (res.status === 200) {

        toastr.success('la zone ' + Qst_FR + " était bien modifié" )
        setopenModal(false)
        initForm()

      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

  }
}


 
  const addZone = async () =>{

    

    

    const formData = new FormData();
    formData.append('file', selectedFiles[0]);

    await UploadFileQuiz(formData).then(async res =>{
      console.log(res)

      const DataPost = {
        "qst_fr": Qst_FR,
        "reponses_ar": JSON.stringify(Res_AR),
        "qst_ar": Qst_AR,
        "reponses_en" : JSON.stringify(Res_EN),
        "reponses_fr" : JSON.stringify(Res_FR),
        "qst_en" : Qst_EN,
        "img" : res,
        "ref" : Qst_FR,
        "correctReponse" : JSON.stringify(selectedCheckboxes),
        "typeFile" : typeFile

      }
    await AddQuiz(DataPost).then(res =>{
      console.log(res.status)
      if (res.status === 201) {

        toastr.success('la zone ' + Qst_FR + " était bien ajouté" )
        setopenModal(false)
        initForm()
        GetData()


      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

    })

    // const blobData = await fetch(URL.createObjectURL(selectedFiles[0])).then((res) => res.blob());
    // const blob = new Blob([blobData], { type: selectedFiles[0].type });
    // formData.append('files', blob, selectedFiles[0].name);


  }

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const handleAddnewZone = () => {
    setQuiOpened({})
    setSelectedCheckboxes([])
    initForm()
    setopenModal(true)
  }

  const handleClickDisable = async () => {

    await disableQuiz(openedQuiz).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmModal(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickRemove = async () => {

    await removeQuiz(openedQuiz).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmRemove(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickEnable = async (Zone) =>{

    await enableQuiz(openedQuiz).then((res) =>{
      console.log(res)
      if (res.status === 200) {
        toastr.success("la zone était bien activé" )
        GetData()
        setShowConfirmModalII(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
     })

  }


  // const updateZone = async () =>{
  //   console.log(memberSelected.profile)
  //   const Data = JSON.parse(localStorage.getItem("authUser"))
  //   memberSelected.profile['adrs_res'] = DesZone
  //   memberSelected.profile['Tel'] = tel
  //   memberSelected.profile['adrs_ferme'] = adr_ferm
  //   memberSelected.profile['City'] = selectedCity?.value
  //   memberSelected.profile['days_dispo'] = JSON.stringify(DaysSelected)

  //   const DataProfile = { Data : memberSelected.profile }
    
  //   await UpdateMemeberProfile(Data.token, DataProfile ).then(res =>{
  //     setopenModal(false)
  //     if(res['status'] == "success"){
  //       toastr.success('le profil de ' + NameZone + " était bien misé à jour" )
  //     }
  //   }).catch(err =>{
  //     toastr.error("Erreur lors de mises à jour le profile ")
  //   })
  // }

  const handleAddResFR = (value,index) =>{
    console.log(value)
    const prevRes = [...Res_FR];
    prevRes[index] = value
    setRes_FR(prevRes)
  }

  const handleAddResAR = (value,index) =>{
    const prevRes = [...Res_AR];
    prevRes[index] = value
    setRes_AR(prevRes)
  }

  const handleAddResEN = (value,index) =>{
    const prevRes = [...Res_EN];
    prevRes[index] = value
    setRes_EN(prevRes)
  }


  // const handleCheckboxChange = (value) => {
  //   setSelectedCheckbox(value); 
  // };

  const handleCheckboxChange = (value) => {
    setSelectedCheckboxes(prevSelected => {
      if (prevSelected.includes(value)) {
        // Remove the value from the array if it's already selected (unchecked)
        return prevSelected.filter(item => item !== value);
      } else {
        // Add the value to the array if it's not selected (checked)
        return [...prevSelected, value];
      }
    });
  };



  const [FilterData, setsetFilterData] = useState([])
  const [searchValue, setsearchValue] =useState('')
  const handleSearch = (e) => {
    const value = e.target.value
    // setsearchValue(value)
    const filtered = ListZones.filter(item => {
      // Filter based on matching any field you want (e.g., name or description)
      return item.qst_fr.toLowerCase().includes(value.toLowerCase());
    });

    setsetFilterData(filtered); // Update filtered data state
  };



  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Quiz questions"
            breadcrumbItems={[]}
          />
        
          <Card>
          <div style={{display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-between'}}>
           <div style={{margin : 10, width : "70%", alignItems : 'center'}}>
           <AvForm >
               <InputGroup style={{marginBottom : 0}}>
                   <AvField
                   style={{ width : 500, marginBottom : 0}}
                   type="text"
                   name="search"
                   value={searchValue}
                   onChange={handleSearch}
                   placeholder="Recherche..."
                   />
                   {searchValue && (
                       <InputGroupText>
                       <Button color="link" onClick={{}}>
                           <i className="fa fa-times-circle" /> 
                       </Button>
                       </InputGroupText>
                   )}
               </InputGroup>
               </AvForm> 
           </div>
           {(User?.role == 2 || User?.role == 3) &&
         <div className="d-flex justify-content-end m-2 mt-2">
               <Button color="success" onClick={handleAddnewZone}>
                   Ajouter une restaurant
               </Button>
         </div>
         }
         </div>
  
            <CardBody>
            <TableContainer
                columns={columns || []}
                data={FilterData || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                // openModalUpdate={openModal}
                // isAddOptions={true}
                ShowPaggination={false}
                handleClickRow={handleClickMember}
                handleClickRemove={(Zone) =>{
                  setopenedQuiz(Zone.id)
                  setShowConfirmRemove(true)
                }}
                handleClickDisable={(Zone) =>{
                  setopenedQuiz(Zone.id)
                  setShowConfirmModal(true)
                }}
                handleClickEnable={(Zone) =>{
                  setopenedQuiz(Zone.id)
                  setShowConfirmModalII(true)

                }}
                dropdownData = {dropdownValues}
                userData={User}
              />
            </CardBody>
          </Card>
                <Modal
                    size="xl"
                    isOpen={openmodal}
                    toggle={() =>{setopenModal(false)}}
                >

                <ModalHeader
                  toggle={() =>{setopenModal(false)}} 
                  close={
                    <i class="fas fa-times" style={{fontSize  : 25, cursor : 'pointer'}} onClick={() =>{setopenModal(false)}}></i>
                  }
                >
                  Question {QuiOpened['title_fr']}

                </ModalHeader>
                <ModalBody>
                  <Row>
                  <Col lg="6">
                  <Label className="form-label" htmlFor="basicpill-firstname-input1">Image</Label>
                    <Dropzone
                        onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                                <div className="dz-message needsclick" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                        <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                    </div>
                                    <div style={{flexDirection  : 'column', display : 'flex'}}>
                                    <span style={{fontSize : 14}}>Déposez les fichiers ici ou cliquez pour télécharger.</span>
                                    {errorsizeFile == true &&
                                      <span style={{fontSize : 12, fontWeight  : 'bold', color : colors.red}}>Le fichier à déployer ne doit pas dépasser 2 Mo.</span>
                                    }
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                    </Col>
                    <Col lg="6">
                    {selectedFiles.some(file => file.type.startsWith('image/')) && (
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                        <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          {selectedFiles.filter(file => file.type.startsWith('image/')).map((file, index) => (
                            <Col key={index} xs="6" sm="4" md="3" lg="2">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                style={{ width: '220%', height: "220%", marginBottom: '10px', }}
                              />
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}

                  {selectedFiles.some(file => file.type.startsWith('audio/')) && (
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                        <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          {selectedFiles.filter(file => file.type.startsWith('audio/')).map((file, index) => (
                            <Col key={index} xs="6" sm="4" md="3" lg="2">
                             <i class="fas fa-file-audio" style={{fontSize : 30}}></i>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}
                     {(!isObjectEmpty(QuiOpened) && selectedFiles.length == 0) &&
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                      <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          <Col xs="6" sm="4" md="3" lg="2">
                           {QuiOpened['typeFile'] == "Image" && 
                            <img
                              src={config.path + QuiOpened["img"]}
                              alt={"icon"}
                              style={{ width: '220%', height: "220%", marginBottom: '10px', }}
                            />
                           }

                        {QuiOpened['typeFile'] == "Audio" && 
                          <i class="fas fa-file-audio" style={{fontSize : 30}}></i>
                        }

                        {QuiOpened['typeFile'] == "Video" && 
                          <i class="fas fa-video" style={{fontSize : 30}}></i>
                        }
                          </Col>
                      </Row>
                    </div> 
                    }


                    {selectedFiles.length > 0 && (
                        <Card className="mt-3">
                            <CardBody>
                                <CardTitle>Fichier Sélectionné</CardTitle>
                                {selectedFiles.map((file, index) => (
                                    <Row key={index} className="align-items-center mb-2">
                                        <Col className="col-auto">
                                            <h6 className="text-truncate font-size-14 mb-0">{file.name}</h6>
                                        </Col>
                                        <Col>
                                            <Badge color="primary">{formatBytes(file.size)}</Badge>
                                        </Col>
                                        <Col className="col-auto">
                                            <Button color="danger" size="sm" onClick={() => handleRemoveFile(index)}><i className="ri-delete-bin-2-line"></i></Button>
                                        </Col>
                                    </Row>
                                ))}
                               
                            </CardBody>
                        </Card>
                    )}
                    </Col>
                    </Row>
           
                <React.Fragment>
                          <Nav pills className="navtab-bg nav-justified mt-2">
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "1" ? "1px solid #e4e4e4" : "none",
                                     }}
                                    className={classnames({
                                      active: activeTab == "1"
                                    })}
                                    onClick={() => {
                                     setactiveTab("1")
                                    }}
                                  >
                                    Francais
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "2" ? "1px solid #e4e4e4" : "none",
                                    }}
                                    className={classnames({
                                      active: activeTab == "2"
                                    })}
                                    onClick={() => {
                                      setactiveTab("2")
                                    }}
                                  >
                                    Arabe
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer",
                                      // border : activeTab !== "3" ? "1px solid #e4e4e4" : "none",
                                     }}
                                    className={classnames({
                                      active: activeTab == "3"
                                    })}
                                    onClick={() => {
                                        setactiveTab("3")
                                    }}
                                  >
                                    Englais
                                  </NavLink>
                                </NavItem>
                              
                        </Nav>
                        <TabContent activeTab={activeTab}>
                        <TabPane tabId="1" className="p-3">
                        <Row>
                          <Col lg="12">

                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Qestion</Label>
                                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Qst_FR } onChange={(e) =>setQst_FR(e.target.value)} />
                                  </div>
                          </Col>
                          </Row>
                          <Row>
                            <Col lg="1" style={{justifyContent : 'space-around', alignItems : 'center', display : 'flex', flexDirection : "column"}}>
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={1}
                                  checked={selectedCheckboxes.includes(1)}
                                  id="checkbox-1"
                                  onChange={() => handleCheckboxChange(1)}
                                />
                              </div>
                            </Row>
                            
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={2}
                                  checked={selectedCheckboxes.includes(2)}
                                  id="checkbox-2"
                                  onChange={() => handleCheckboxChange(2)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={3}
                                  checked={selectedCheckboxes.includes(3)}
                                  id="checkbox-3"
                                  onChange={() => handleCheckboxChange(3)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={4}
                                  checked={selectedCheckboxes.includes(4)}
                                  id="checkbox-4"
                                  onChange={() => handleCheckboxChange(4)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(5)}
                                  id="checkbox-5"
                                  onChange={() => handleCheckboxChange(5)}
                                />
                              </div>
                            </Row>
                             <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(6)}
                                  id="checkbox-6"
                                  onChange={() => handleCheckboxChange(6)}
                                />
                              </div>
                            </Row>

                            </Col>
                            <Col lg="11">
                              <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(1) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 0)} value={Res_FR[0] }></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(2) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 1)} value={Res_FR[1]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(3) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 2)} value={Res_FR[2]}></Input>
                                    </div>
                                </Col>
                                
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(4) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 3)} value={Res_FR[3]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(5) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 4)} value={Res_FR[4]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(6) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResFR(e.target.value, 5)} value={Res_FR[5]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>
                            </Col>
                          </Row>
                          </TabPane>
                        <TabPane tabId="2" className="p-3">

                          <Row>
                          <Col lg="12">

                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Qestion</Label>
                                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Qst_AR } onChange={(e) =>setQst_AR(e.target.value)} />
                                  </div>
                          </Col>
                          </Row>
                          <Row>
                          <Col lg="1" style={{justifyContent : 'space-around', alignItems : 'center', display : 'flex', flexDirection : "column"}}>
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={1}
                                  checked={selectedCheckboxes.includes(1)}
                                  id="checkbox-1"
                                  onChange={() => handleCheckboxChange(1)}
                                />
                              </div>
                            </Row>
                            
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={2}
                                  checked={selectedCheckboxes.includes(2)}
                                  id="checkbox-2"
                                  onChange={() => handleCheckboxChange(2)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={3}
                                  checked={selectedCheckboxes.includes(3)}
                                  id="checkbox-3"
                                  onChange={() => handleCheckboxChange(3)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={4}
                                  checked={selectedCheckboxes.includes(4)}
                                  id="checkbox-4"
                                  onChange={() => handleCheckboxChange(4)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(5)}
                                  id="checkbox-5"
                                  onChange={() => handleCheckboxChange(5)}
                                />
                              </div>
                            </Row>
                             <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(6)}
                                  id="checkbox-6"
                                  onChange={() => handleCheckboxChange(6)}
                                />
                              </div>
                            </Row>

                            </Col>
                            <Col lg="11">
                              <Row>
                                
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(1)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value,0)} value={Res_AR[0] }></Input>
                                    </div>
                                </Col>
                                
                            </Row>

                            <Row>
                               
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(2)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value,1)} value={Res_AR[1]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(3)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value,2)} value={Res_AR[2]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>
                            <Row>
                               
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(4)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value,3)} value={Res_AR[3]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(5) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value, 4)} value={Res_AR[4]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(6) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResAR(e.target.value, 5)} value={Res_AR[5]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>
                            </Col>
                          </Row>
                          </TabPane>
                        <TabPane tabId="3" className="p-3">
                          <Row>
                          <Col lg="12">

                          <div className="mb-3">
                              <Label className="form-label" htmlFor="basicpill-firstname-input1">Qestion </Label>
                              <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Qst_EN } onChange={(e) =>setQst_EN(e.target.value)} />
                          </div>
                          </Col>
                          </Row>
                          <Row>
                          <Col lg="1" style={{justifyContent : 'space-around', alignItems : 'center', display : 'flex', flexDirection : "column"}}>
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={1}
                                  checked={selectedCheckboxes.includes(1)}
                                  id="checkbox-1"
                                  onChange={() => handleCheckboxChange(1)}
                                />
                              </div>
                            </Row>
                            
                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={2}
                                  checked={selectedCheckboxes.includes(2)}
                                  id="checkbox-2"
                                  onChange={() => handleCheckboxChange(2)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={3}
                                  checked={selectedCheckboxes.includes(3)}
                                  id="checkbox-3"
                                  onChange={() => handleCheckboxChange(3)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={4}
                                  checked={selectedCheckboxes.includes(4)}
                                  id="checkbox-4"
                                  onChange={() => handleCheckboxChange(4)}
                                />
                              </div>
                            </Row>

                            <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(5)}
                                  id="checkbox-5"
                                  onChange={() => handleCheckboxChange(5)}
                                />
                              </div>
                            </Row>
                             <Row lg="4">
                              <div>
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={5}
                                  checked={selectedCheckboxes.includes(6)}
                                  id="checkbox-6"
                                  onChange={() => handleCheckboxChange(6)}
                                />
                              </div>
                            </Row>

                            </Col>
                            <Col lg="11">
                              <Row>
                                
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(1)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResEN(e.target.value,0)} value={Res_EN[0] }></Input>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                               
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(2)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResEN(e.target.value,1)} value={Res_EN[1]}></Input>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                               
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(3)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"   onChange={(e) =>handleAddResEN(e.target.value,2)} value={Res_EN[2]}></Input>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                               
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(4)</Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResEN(e.target.value,3)} value={Res_EN[3]}></Input>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(5) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResEN(e.target.value, 4)} value={Res_EN[4]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="basicpill-address-input1">Reponse(6) </Label>
                                        <Input id="basicpill-address-input1" className="form-control"  onChange={(e) =>handleAddResEN(e.target.value, 5)} value={Res_EN[5]}></Input>
                                    </div>
                                </Col>
                               
                            </Row>
                            </Col>
                          </Row>
                          </TabPane>
                       
                        </TabContent>
                          <Row>
                          

                          

                          

                          
                          
                        </Row>
                        {/* <Row>
                           <Label style={{ fontSize: 12, fontWeight : "bold", color : colors.red }} className="form-label" htmlFor="basicpill-firstname-input1">🔔 Merci de sélectionner une seule réponse correcte parmi les choix proposés pour le quiz !</Label>
                        </Row> */}
                      </React.Fragment>
              </ModalBody>
                      {!isObjectEmpty(QuiOpened) ? 
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                        {(User?.role == 2 || User?.role == 3) && 
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={handleupdateQuiz}
                          >
                              Mise à jour
                          </Button>
                        }
                      </div>
                       :
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={addZone}
                          >
                              Enregistrer
                          </Button>
                      </div>
                  }

          </Modal>

          <Modal
                size="xl"
                isOpen={openmodalevaluate}
                toggle={() =>{setopenmodalevaluate(false)}}
                >
                <ModalHeader >
                  Evaluation le membre : {memberSelected?.NomComplet}
                </ModalHeader>
                <ModalBody>
                    <Row>
                      <Col lg="12">
                          <div className="mb-3">
                              <Label className="form-label" htmlFor="basicpill-address-input1">Année d'évaluation</Label>
                              <Input type="text" className="form-control" id="basicpill-phoneno-input3" onChange={(e) =>setevaluatYear(e.target.value)} value={evaluatYear}/>
                          </div>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg="12">
                        <div className="mb-3">
                            <Label className="form-label" htmlFor="basicpill-address-input1">Commentaire</Label>
                            <textarea id="basicpill-address-input1" className="form-control" rows="2" onChange={(e) =>setevaluatCmnt(e.target.value)} value={evaluatCmnt}></textarea>
                        </div>
                    </Col>
                    </Row>
                </ModalBody>
                <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                          >
                              Enregistrer
                          </Button>
                      </div>
          </Modal>

          <Modal
               isOpen={ShowConfirmModal}
               toggle={() => setShowConfirmModal(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModal(false) }>
                Désactiver la page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous désactiver cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModal(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickDisable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          <Modal
               isOpen={ShowConfirmModalII}
               toggle={() => setShowConfirmModalII(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModalII(false) }>
                Activer la Page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous activer cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModalII(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickEnable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>
          <Modal
               isOpen={ShowConfirmRemove}
               toggle={() => setShowConfirmRemove(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmRemove(false) }>
                Supprimer la question
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous supprimer cette question? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmRemove(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickRemove} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          
        </Container>
        {/* <Modal
            isOpen={modalUpdateIsOpen}
            onRequestClose={closeModal} 
            style={customStyles}
          ></Modal> */}
      </div>
    </React.Fragment>
  );
};

export default Quiz;
